// import React, { useState } from 'react';

// const InviteFriendModal = ({ setIsShowInviteFriendModal }) => {
//     const [showMessengers, setShowMessengers] = useState(false);

//     return (
//         <div
//             className="fade-in modal z-50 fixed top-0 w-full h-screen flex items-center justify-center bg-[#161414a1]"
//             onClick={(e) => {
//                 if (e.target.className.includes('modal')) {
//                     setIsShowInviteFriendModal(false);
//                 }
//             }}
//         >
//             <div className="rounded-xl p-4 bg-white flex flex-col  justify-center gap-2 w-[40%] shadow-sm relative">

//                 <div className='flex justify-between items-center'>
//                     <h2 className="text-lg font-bold mb-2 whitespace-nowrap">دعوت از دوستان</h2>
//                     {/* Close Icon */}
//                     <div className="flex items-end justify-end w-full p-2">
//                         <img
//                             onClick={() => setIsShowInviteFriendModal(false)}
//                             src="/icons/close-black.svg"
//                             alt="close"
//                             className="cursor-pointer"
//                         />
//                     </div>
//                 </div>

//                 <div>
//                     <p className='font-medium text-center mb-3'>با دعوت از هر یک از دوستانتان، می‌توانید پس از تائید ثبت‌نامشان، امتیاز دریافت کنید</p>
//                 </div>

//                 <div className='w-full flex items-center gap-4'>
//                     {/* Phone Input */}
//                     <div className='w-4/6'>
//                         <span>شماره تلفن همراه</span>
//                         <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 ">
//                             <input
//                                 pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
//                                 type="tel"
//                                 // placeholder="شماره تلفن همراه"
//                                 className="w-full border-none focus:outline-none"
//                             />
//                             <span className="ml-2 text-gray-500 border-r border-gray-500 pr-3">98+</span>

//                         </div>
//                     </div>



//                     <button
//                         className="mt-6 bg-[#157BD1] text-white text-[12px] px-4 py-2 rounded-lg w-2/6"
//                         onClick={() => setShowMessengers(!showMessengers)}
//                     >
//                         انتخاب از مخاطبین
//                     </button>
//                 </div>


//                 {/* Send Message Button */}
//                 <button
//                     className="mt-4 bg-[#157BD1] text-white px-4 py-2 rounded-lg w-full"
//                     onClick={() => setShowMessengers(!showMessengers)}
//                 >
//                     ارسال دعوتنامه از طریق ...
//                 </button>

//                 {/* Messenger Icons */}
//                 {/* {showMessengers && (
//                     <div className="flex gap-4 mt-4">
//                         <img src="/icons/telegram.svg" alt="telegram" className="w-8 h-8" />
//                         <img src="/icons/whatsapp.svg" alt="whatsapp" className="w-8 h-8" />
//                         <img src="/icons/sms.svg" alt="sms" className="w-8 h-8" />
//                     </div>
//                 )} */}




//             </div>
//         </div>
//     );
// };

// export default InviteFriendModal;



import React, { useEffect, useState } from 'react';
import { RWebShare } from "react-web-share";
import { useAuth } from '../../pages/login/connect/Login';
const InviteFriendModal = ({ setIsShowInviteFriendModal }) => {
    const [isSelectMessengerModal, setIsSelectMessengerModal] = useState(false);
    const [copyMessage, setCopyMessage] = useState("")
    const handleClose = () => {
        setIsShowInviteFriendModal(false);
        setIsSelectMessengerModal(false);
    };
    const { getUserInfoByToken } = useAuth((state) => state.actions);
    const referringCode = useAuth((state) => state.referringCode);
    useEffect(() => {
        getUserInfoByToken()
    }, [])
    const sendInvitationHandler = async () => {
        setIsSelectMessengerModal(true)
        // if (navigator.canShare) {
        //     navigator.share({
        //         title: "pelake man",
        //         text: "اشنراک گزاری کاربر پلاک من",
        //         url: `https://www.new.pelakeman/invitation/?referCode=${referringCode}`,
        //     });
        // } else {
        //     alert("درحال حاضر امکان به اشتراک گزاشتن کاربر وجود ندارد لطفا بعدا تلاش کنید")
        // }
    }
    const copyToClipboard = () => {
        navigator.clipboard.writeText(referringCode)
            .then(() => setCopyMessage("کد با موفقیت کپی شد!"))
            .catch((error) => console.error("Copy failed:", error));
    }
    return (
        <div
            className="fade-in modal z-50 fixed top-0 w-full h-screen flex items-center justify-center bg-[#161414a1]"
            onClick={(e) => {
                if (e.target.className.includes('modal')) {
                    handleClose();
                }
            }}
        >
            {/* Check which modal to display */}
            {isSelectMessengerModal ? (
                <div className="rounded-xl p-4 bg-white flex flex-col justify-center gap-2 w-[40%] shadow-sm relative">
                    <div className='flex justify-between items-center'>
                        {/* Back Icon */}
                        <h2 className="text-lg font-bold mb-2 whitespace-nowrap"> ارسال دعوتنامه از طریق ... </h2>
                        <div className="cursor-pointer" onClick={() => setIsSelectMessengerModal(false)}>
                            <img src="/icons/pelak-arrow-back-simple.svg" alt="back" className="w-6 h-6" />
                        </div>
                        {/* <div className="flex items-end justify-end w-full p-2">
                            <img
                                onClick={handleClose}
                                src="/icons/close-black.svg"
                                alt="close"
                                className="cursor-pointer"
                            />
                        </div> */}
                    </div>

                    {/* Messenger Icons */}
                    <div className="flex gap-4 mt-4 justify-center">
                        <img src="/icons/telegram.svg" alt="telegram" className="w-8 h-8" />
                        <img src="/icons/whatsapp.svg" alt="whatsapp" className="w-8 h-8" />
                        <img src="/icons/sms.svg" alt="sms" className="w-8 h-8" />
                    </div>
                </div>
            ) : (
                <div className="rounded-xl p-4 bg-white flex flex-col justify-center gap-2 w-[40%] sm:w-full shadow-sm relative">
                    <div className='flex justify-between items-center'>
                        <h2 className="text-lg font-bold mb-2 whitespace-nowrap">دعوت از دوستان</h2>
                        {/* Close Icon */}
                        <div className="flex items-end justify-end w-full p-2">
                            <img
                                onClick={handleClose}
                                src="/icons/close-black.svg"
                                alt="close"
                                className="cursor-pointer"
                            />
                        </div>
                    </div>

                    <div>
                        <p className='font-medium text-center mb-3'>با دعوت از هر یک از دوستانتان، می‌توانید پس از تائید ثبت‌نامشان، امتیاز دریافت کنید
                            <div className='flex items-center justify-center my-5'>
                                <p>  کد معرفی شما :</p>
                                <div className='flex justify-between items-center' onClick={copyToClipboard}>
                                    <div>{referringCode}</div>
                                    <img src='/icons/copy-1.svg' />
                                </div>
                              
                            </div>
                             {copyMessage && <p className='text-[14px] text-green-800'>{copyMessage}</p>}
                        </p>
                    </div>

                    <div className='w-full  items-center gap-4'>
                        {/* Phone Input */}
                        {/* <div className='w-4/6'> */}
                        <div className='w-6/6'>
                            <span>شماره تلفن همراه</span>
                            <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 ">
                                <input
                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                    type="tel"
                                    className="w-full border-none focus:outline-none"
                                />
                                <span className="ml-2 text-gray-500 border-r border-gray-500 pr-3">98+</span>
                            </div>
                        </div>

                        {/* <button
                            className="mt-6 bg-[#157BD1] text-white text-[12px] px-4 py-2 rounded-lg w-2/6"
                        >
                            انتخاب از مخاطبین
                        </button> */}
                    </div>

                    {/* Send Message Button */}



                    <RWebShare
                        data={{
                            text: "پلاک من ", 
                            url: `https://www.new.pelakeman/invitation/?referCode=${referringCode}`,
                            title: "پلاک من ",
                        }}

                    >
                        <button
                            className="mt-4 bg-[#157BD1] text-white px-4 py-2 rounded-lg w-full"
                            onClick={() => sendInvitationHandler}
                        >
                            ارسال دعوتنامه از طریق ...
                        </button>
                    </RWebShare>
                </div>
            )}
        </div>
    );
};

export default InviteFriendModal;
